(() => {
  const euros = value => new Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(value);
  const percent = value => new Intl.NumberFormat('es-ES', { maximumFractionDigits: 3 }).format(value) + ' %';
  const monthly = (capital, annual, years) => {
    const n = years * 12, r = annual / 1200;
    return r === 0 ? capital / n : capital * r / (1 - Math.pow(1 + r, -n));
  };
  const csvCells = line => {
    const cells = []; let cell = '', quoted = false;
    for (let i = 0; i < line.length; i++) {
      const char = line[i];
      if (char === '"') {
        if (quoted && line[i + 1] === '"') { cell += '"'; i++; }
        else quoted = !quoted;
      } else if (char === ',' && !quoted) { cells.push(cell); cell = ''; }
      else cell += char;
    }
    cells.push(cell);
    return cells;
  };
  const officialSeries = async (flow, key) => {
    const url = 'https://data-api.ecb.europa.eu/service/data/' + flow + '/' + key + '?lastNObservations=1&format=csvdata';
    const response = await fetch(url, { mode: 'cors', credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(8500) });
    if (!response.ok) throw new Error('Datos no disponibles');
    const lines = (await response.text()).trim().split(/\r?\n/).filter(Boolean);
    if (lines.length < 2) throw new Error('Datos no disponibles');
    const columns = csvCells(lines[0]);
    const dateColumn = columns.indexOf('TIME_PERIOD'), valueColumn = columns.indexOf('OBS_VALUE');
    if (dateColumn < 0 || valueColumn < 0) throw new Error('Formato no disponible');
    const values = csvCells(lines[lines.length - 1]);
    const value = Number(values[valueColumn]), date = values[dateColumn];
    if (!Number.isFinite(value) || value < -5 || value > 30 || !/^\d{4}-\d{2}$/.test(date)) throw new Error('Dato no válido');
    return { value, date };
  };
  const period = value => {
    const [year, month] = value.split('-').map(Number);
    return new Intl.DateTimeFormat('es-ES', { month: 'long', year: 'numeric' }).format(new Date(year, month - 1, 1));
  };
  document.querySelectorAll('[data-okhomes-mortgage]').forEach(root => {
    if (root.dataset.mortgageReady) return;
    root.dataset.mortgageReady = 'true';
    const dialog = root.querySelector('dialog'), form = root.querySelector('form');
    const field = key => root.querySelector('[data-mortgage-' + key + ']');
    const adjust = root.querySelector('.okhomes-mortgage__adjust');
    let ratesPromise, fixedDate = '', euriborDate = '';
    const number = key => {
      const raw = field(key).value.trim().replace(/\s/g, '');
      const normalized = key === 'price' || key === 'contribution' ? raw.replace(/\./g, '').replace(',', '.') : raw.replace(',', '.');
      const value = normalized === '' ? NaN : Number(normalized);
      return Number.isFinite(value) ? value : null;
    };
    const calculate = () => {
      const price = number('price'), contribution = number('contribution'), years = number('years');
      const fixedRate = number('fixed-rate'), euribor = number('euribor'), spread = number('spread');
      const cap = price !== null && price > 0 ? price * .8 : null;
      field('eighty').textContent = cap === null ? '—' : euros(cap);
      const valid = cap !== null && contribution !== null && contribution >= 0 && years !== null && years >= 1 && years <= 40;
      const loan = valid ? Math.min(cap, Math.max(0, price - contribution)) : null;
      const gap = valid ? Math.max(0, price - cap - contribution) : null;
      const variableRate = euribor !== null && spread !== null ? Math.max(0, euribor + spread) : null;
      const fixedPayment = loan !== null && fixedRate !== null && fixedRate >= 0 ? monthly(loan, fixedRate, years) : null;
      const variablePayment = loan !== null && variableRate !== null ? monthly(loan, variableRate, years) : null;
      field('loan').textContent = loan === null ? 'Indica tu aportación' : euros(loan);
      field('gap').textContent = gap === null ? '—' : gap > 0 ? euros(gap) : 'Entrada cubierta';
      field('fixed-display').textContent = fixedRate === null ? '—' : percent(fixedRate);
      field('variable-display').textContent = variableRate === null ? '—' : percent(variableRate);
      field('fixed-payment').textContent = fixedPayment === null ? '—' : euros(fixedPayment) + '/mes';
      field('variable-payment').textContent = variablePayment === null ? '—' : euros(variablePayment) + '/mes';
      return { valid, price, contribution, years, loan, gap, fixedRate, euribor, spread, variableRate, fixedPayment, variablePayment };
    };
    const formatAmount = key => {
      const input = field(key), value = number(key);
      if (value !== null && Number.isFinite(value) && value >= 0) {
        input.value = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 }).format(value);
      }
    };
    formatAmount('price');
    field('price').addEventListener('blur', () => formatAmount('price'));
    field('contribution').addEventListener('blur', () => formatAmount('contribution'));
    const loadRates = () => {
      if (ratesPromise) return ratesPromise;
      const fixed = officialSeries('MIR', 'M.ES.B.A2C.P.R.A.2250.EUR.N').then(data => {
        fixedDate = data.date;
        if (!field('fixed-rate').dataset.edited) field('fixed-rate').value = String(data.value);
        field('fixed-source').textContent = 'BCE, nueva financiación de vivienda en España con fijación superior a diez años: ' + period(data.date) + '.';
        calculate();
      }).catch(() => {
        field('fixed-source').textContent = 'No se pudo consultar el tipo fijo oficial. Puedes escribir un tipo para la simulación.';
        adjust.open = true;
      });
      const variable = officialSeries('FM', 'M.U2.EUR.RT.MM.EURIBOR1YD_.HSTA').then(data => {
        euriborDate = data.date;
        if (!field('euribor').dataset.edited) field('euribor').value = String(data.value);
        field('variable-source').textContent = 'BCE, euríbor a 12 meses: ' + period(data.date) + '. Se suma el diferencial que puedes ajustar.';
        calculate();
      }).catch(() => {
        field('variable-source').textContent = 'No se pudo consultar el euríbor oficial. Puedes escribirlo para la simulación.';
        adjust.open = true;
      });
      ratesPromise = Promise.allSettled([fixed, variable]);
      return ratesPromise;
    };
    root.querySelectorAll('.okhomes-mortgage__simple input, .okhomes-mortgage__adjust input').forEach(input => {
      input.addEventListener('input', () => {
        if (input === field('fixed-rate') || input === field('euribor')) input.dataset.edited = 'true';
        input.setCustomValidity('');
        calculate();
      });
    });
    field('open').addEventListener('click', () => { if (!dialog.open) dialog.showModal(); calculate(); loadRates(); });
    field('close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    form.addEventListener('submit', event => {
      const result = calculate();
      for (const key of ['price', 'contribution', 'years', 'fixed-rate', 'euribor', 'spread']) {
        const input = field(key);
        if (number(key) === null || !Number.isFinite(number(key)) || !input.checkValidity()) {
          event.preventDefault();
          adjust.open = true;
          if (number(key) === null) input.setCustomValidity('Completa este dato para enviar el estudio.');
          input.reportValidity(); input.focus(); return;
        }
      }
      if (!result.valid || result.contribution > result.price || !Number.isFinite(result.fixedPayment) || !Number.isFinite(result.variablePayment)) {
        event.preventDefault(); field('contribution').setCustomValidity('Revisa la aportación y los importes del estudio.'); field('contribution').reportValidity(); field('contribution').focus(); return;
      }
      const contact = field('contact').checked ? 'Sí' : 'No';
      const values = {
        price: euros(result.price), loan: euros(result.loan), contribution: euros(result.contribution),
        gap: euros(result.gap), years: String(result.years), contact,
        'fixed-payment': euros(result.fixedPayment) + '/mes',
        'variable-payment': euros(result.variablePayment) + '/mes',
        rates: 'Fijo ' + percent(result.fixedRate) + (fixedDate ? ' (BCE ' + fixedDate + ')' : ' (introducido por usuario)') +
          '; variable ' + percent(result.euribor) + ' + ' + percent(result.spread) +
          (euriborDate ? ' (euríbor BCE ' + euriborDate + ')' : ' (euríbor introducido por usuario)')
      };
      Object.entries(values).forEach(([key, value]) => {
        const target = field('send-' + key);
        if (target) target.value = value;
      });
      field('send-body').value = 'Estudio de hipoteca de ' + (root.dataset.propertyReference || '') + ' · ' +
        (root.dataset.propertyTitle || '') + '\nPrecio: ' + values.price +
        '\n80 % orientativo: ' + euros(result.price * .8) +
        '\nAportación: ' + values.contribution + '\nHipoteca estimada: ' + values.loan +
        '\nFalta para entrada: ' + values.gap + '\nPlazo: ' + values.years + ' años' +
        '\n' + values.rates + '\nCuota fija: ' + values['fixed-payment'] +
        '\nCuota variable inicial: ' + values['variable-payment'] +
        '\nSolicita contacto hipotecario: ' + contact;
    });
    field('contact').addEventListener('change', () => { field('send-contact').value = field('contact').checked ? 'Sí' : 'No'; });
    calculate();
    if(new URLSearchParams(location.search).has('okhomes_mortgage'))field('open').click();
    if (root.querySelector('[data-mortgage-feedback]')) { dialog.showModal(); loadRates(); }
  });
})();